// 앱 표시 메타 — 화면(MY 탭 푸터)·의견 메일·문의 시트가 같은 값을 써야 해서 한 곳에 둔다.
// 빌드 시각은 vite.config가 주입하는 전역 __BUILD_TIME__를 그대로 쓴다.
//
// 🔴 2026-09-15: 종전엔 `APP_VERSION = "v2.0.0"`이 손으로 박혀 있었다 — 실제 스토어 버전은 1.0.2라
//   사용자 화면과 문의 메일에 **틀린 버전**이 찍혔다. 이제 네이티브 앱은 App.getInfo()로 번들의
//   실제 버전을 읽고(버전을 올려도 코드 수정 불필요), 웹·첫 렌더는 빌드 시점에 네이티브 프로젝트에서
//   읽어 온 __APP_VERSION__을 쓴다.
import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

/** 동기 폴백 — 네이티브 프로젝트의 MARKETING_VERSION(빌드 시점). 못 읽었으면 빈 문자열. */
export const APP_VERSION = __APP_VERSION__ ? `v${__APP_VERSION__}` : "";

let cached: Promise<string> | null = null;
/** 표시용 버전. 네이티브면 번들의 실제 버전, 웹이면 빌드 시점 값. 한 번만 조회한다. */
export function getAppVersion(): Promise<string> {
  if (!cached) {
    cached = Capacitor.isNativePlatform()
      ? App.getInfo().then((i) => `v${i.version}`).catch(() => APP_VERSION)
      : Promise.resolve(APP_VERSION);
  }
  return cached;
}

/** 렌더용 훅 — 첫 렌더는 폴백, 네이티브 값이 오면 교체(보통 같은 값이라 깜빡임이 없다). */
export function useAppVersion(): string {
  const [v, setV] = useState(APP_VERSION);
  useEffect(() => { let alive = true; getAppVersion().then((x) => { if (alive) setV(x); }); return () => { alive = false; }; }, []);
  return v;
}
